// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"261":"70124721","284":"b9630df4","473":"b9630df4","826":"2818b0c3","853":"b9630df4"}[chunkId] + ".chunk.css";
};